import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Design } from '@/model/document2/page/surface/design/design';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { Vector2 } from '@/utilityModels/vector2';

// 多角形レイヤーの制御点適用コマンド
export class ApplyPolygonControlPointsCommand implements ICommandBase
{
    private layer! : PolygonLayer;
    private points! : Array<Vector2>;
    private doneCallback! : () => void;

    private srcPoints! : Array<Vector2>;

    constructor(layer : PolygonLayer, points : Array<Vector2>, doneCallback : () => void)
    {
        this.layer = layer;
        this.points = points;
        this.doneCallback = doneCallback;
        // 以前の値保持
        this.srcPoints = layer.controlPoints;
    }

    public do() : void
    {
        // 適用
        this.layer.applyViewControlPoints(this.points);

        this.doneCallback();
    }

    public undo() : void
    {
        // 戻す
        this.layer.controlPoints = this.srcPoints;

        this.doneCallback();
    }

    public redo() : void
    {
        // 適用
        this.layer.applyViewControlPoints(this.points);

        this.doneCallback();
    }
}